import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts"" />
import React from 'react';
import { connect } from 'react-redux';
import PageableList from '../pageable-list/pageable-list';
import { buildDispatchable } from '../../actions/_action-utilities';
import * as dictionaryActions from '../../actions/dictionary';
import BreadCrumbsComponent from '../breadcumbs/breadcrumbs';
const DictionaryTenantList = (props)=>{
    const { list, orgId } = props;
    const handleList = (e)=>{
        list(orgId);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(BreadCrumbsComponent, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "layout-inner-header",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "container heading",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "columns col-gapless",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "column col-11",
                            children: /*#__PURE__*/ _jsx("h4", {
                                children: "Dictionaries"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: 'qa-dictionary-list-container',
                children: //@ts-ignore
                /*#__PURE__*/ _jsx(PageableList, {
                    ...props,
                    list: handleList
                })
            })
        ]
    });
};
const mapStateToProps = function(state) {
    const { dictionaryTenants, ui } = state;
    let adminTabs = ui.actionGroups.find((actionGroup)=>{
        return actionGroup.key === 'admin';
    })?.options[0].subActions.filter((tab)=>{
        return ui.context.activeContext?.resources.find((resource)=>{
            return resource.resourceName === tab.resourceId;
        });
    }) ?? [];
    return {
        ...dictionaryTenants,
        columnDefs: dictionaryTenants.columnDefs,
        items: dictionaryTenants.sortablePageable.pageableDefinition.content,
        itemName: 'Organizations',
        orgId: ui.context.activeContext?.organizationId ?? -1,
        showHeader: adminTabs?.length <= 1
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        onSelection: (item)=>{
            runDispatchable(()=>{
                //@ts-ignore
                return dispatch(dictionaryActions.loadDictionaries(item));
            });
        },
        list: (options)=>{
            runDispatchable(()=>{
                return dispatch(dictionaryActions.getTenantList(options));
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DictionaryTenantList);
